import React from "react";
import { NavLink as RouterNavLink, useLocation } from "react-router-dom";
import Can from "../../auth/Can";
import roles from "../../auth/roles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    UncontrolledTooltip
} from "reactstrap";

const CollaudoNav = ({ path }) => {
    let location = useLocation();
    const [color, setColor] = React.useState(color);

    React.useEffect(() => {
        const newColor = window.location.pathname.includes(path) ? "primary" : "secondary";
        setColor(newColor);
    }, [location]);

    return (
        <Can
            roles={[roles.ADMIN, roles.COLLAUDO]}
            yes={() => (
                <UncontrolledDropdown className="ml-1 mt-1">
                    <DropdownToggle color={color} id="collaudoNavBtn" caret>
                        <FontAwesomeIcon icon="cogs" /><span className="d-none d-xl-block">Collaudi</span>
                    </DropdownToggle>
                    <UncontrolledTooltip placement="auto" popperClassName="tooltip-primary" target="collaudoNavBtn">
                        Collaudi
                    </UncontrolledTooltip>
                    <DropdownMenu>
                        <DropdownItem
                            tag={RouterNavLink}
                            to={`${path}/start-collaudo`}
                            className="dropdown-profile"
                            activeClassName="router-link-exact-active-nav"
                        >
                            <FontAwesomeIcon icon="users-cog" className="mr-1" /> Nuovo collaudo
                        </DropdownItem>

                        <DropdownItem
                            tag={RouterNavLink}
                            to={`${path}/list`}
                            className="dropdown-profile"
                            activeClassName="router-link-exact-active-nav"
                        >
                            <FontAwesomeIcon icon="list" className="mr-1" /> Elenco Collaudi
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledDropdown>
            )}
            no={() => null}
        />
    );
};

export default CollaudoNav;
